import {Component, Input, OnInit} from '@angular/core';
import {Guest} from '../../models/guest.model';
import {Utilities} from '../../utils/utilities';
import {ReservationService} from '../../services/reservation.service';
import {TranslateService} from '@ngx-translate/core';
import {DataManipulationService} from '../../services/data-manipulation.service';
import {NotificationService} from '../../services/notification.service';
import { AttachmentUrlService } from "../../services/attachment-url.service";

@Component({
  selector: 'app-reservation-card-edit',
  templateUrl: './reservation-card-edit.component.html',
  styleUrls: ['./reservation-card-edit.component.scss']
})
export class ReservationCardEditComponent implements OnInit {

  @Input() reservation: any;
  selecTableDiys: any[];
  selectedDiys: any[] = [];
  isLoading: Boolean = true;

  constructor(private reservationService: ReservationService,
              private attachmentUrlService: AttachmentUrlService,
              private translate: TranslateService,
              private dataManipulationService: DataManipulationService,
              private notificationService: NotificationService) { }

  ngOnInit(): void {
    while (this.reservation.guests.length < this.reservation.personCount) {
      this.addNewGuest()
    }
    let carteDiys = [];
    this.reservation.carte.carteDiys.forEach(diy =>{
      if (diy.available){
        this.dataManipulationService.addNameToElement(diy.diy);
        carteDiys.push(diy.diy);
      }
    });
    this.selecTableDiys = Utilities.createMultiSelectElements(carteDiys, 'id', 'name');
    this.isLoading = false;
  }

  addNewGuest() {
    if (this.reservation.personCount <= this.reservation.guests.length) return;
    this.reservation.guests.push(new Guest("Guest " + (this.reservation.guests.length + 1)));
  }

  setEdit() {
    this.reservationService.reservationIsEditStatusChange(this.reservation.id);
    this.reservation.isEdit = !this.reservation.isEdit;
  }

  addNewDiyToGuest($event: any, guestIndex: number) {
    this.isLoading = true;
    this.reservation.guests[guestIndex].preorderedDiys.push($event.entity);
    this.selectedDiys = [];
    if (this.reservation.guests[guestIndex].id > 0){
      this.reservationService.addNewDiyToGuest(this.reservation.guests[guestIndex].id, $event.entity.id).subscribe(response => {
        this.notificationService.showSuccess("general.success");
      });
    } else {
      let listToSave = [];
      listToSave.push(this.reservation.guests[guestIndex]);
      this.reservationService.saveNewGuestWithDiy(this.reservation.reservationNumber, listToSave).subscribe(response =>{
        this.notificationService.showSuccess("general.success");
      });
    }
  }

  deleteDiyFromGuest(diyIndex: number, guestIndex: number) {
    this.isLoading = true;
    this.reservationService.deleteDiyFromGuest(this.reservation.guests[guestIndex].id, this.reservation.guests[guestIndex].preorderedDiys[diyIndex].diy.id).subscribe(response => {
      this.notificationService.showSuccess("general.success");
    });
  }

  /**
   * @deprecated The method should not be used
   */
  saveGuestList(){
    this.reservationService.saveGuestsForReservation(this.reservation).subscribe(response => {
      this.notificationService.showSuccess("general.success");
    });
  }

  /**
   * @deprecated The method should not be used
   */
  private manipulatePreorderedDiyListToSave() {
    this.reservation.guests.forEach(guest => {
      let oldPreorderedDiyList = guest.preorderedDiys;
      guest.preorderedDiys = [];
      oldPreorderedDiyList.forEach(diyListElement => {
        guest.preorderedDiys.push(diyListElement.diy);
      });
    });
  }

}
